import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.scss';

const Loader = ({ loading }) => {

    return (
        <>
            <div className={classNames({ loader: loading })}>
                <div className='loader__spinner' />
            </div>
        </>
    );
};

export default Loader;

Loader.propTypes = {
    loading: PropTypes.bool,
    label: PropTypes.string
}

Loader.defaultProps = {
    loading: false,
    label: ''
}
